import { createClient } from "contentful";

export default createClient({
  space: "wtma1vhii2ij",
  accessToken: "9vhwnItgbcCXnWS62O8K9Na8DK1QQ7PQmT6nc9yeWyo",
});
